<template>
    <div class="text-center">
      <v-dialog dark v-model="dialog" width="950"> 

        <v-card>
        <v-card-title class="text-h5" style="background-color: #161d30;"> Cierre de Operacion </v-card-title>

        <v-card-text style="background-color: #283045;">
            <v-form ref="form" v-model="valid" lazy-validation>  

                <div class="pt-4">
                  <v-simple-table :loading="loading">
                    <template v-slot:default>
                    <thead>
                        <tr>
                          <th class="text-left" style="min-width: 180px;"> </th>
                          <th class="text-left"> Egreso </th>
                          <th class="text-left"> Ingreso </th>
                          <th class="text-left" style="padding-left: 3em;"> Calculado </th>
                          <th class="text-left" style="min-width: 150px;"> Contado </th>
                          <th class="text-left"> Diferencia </th> 
                        </tr>
                    </thead>
                    <tbody> 
                        <tr v-for="(d,i) in denominaciones" :key="i">
                            <td> {{ d.text }} </td>
                            <td style="min-width: 120px;"> {{ d.egreso }} </td>
                            <td style="min-width: 120px;"> {{ d.ingreso }} </td>
                            <td> <v-text-field :value="d.calculado" readonly prefix="Bs." type="number" dense outline hide-details></v-text-field>  </td>
                            <td style="min-width: 120px;"> 
                              <v-text-field v-if="i==0" v-model="d.contado" readonly type="number" dense outline hide-details>
                                <template v-slot:prepend>
                                  <v-btn v-if="i==0" tile small dark outlined color="green darken-4" class="mr-0" @click="opencontador(d)">
                                    <v-icon center>mdi-dice-4</v-icon>
                                  </v-btn>
                                  <div v-else style="min-width: 50px;"></div>
                                </template>
                              </v-text-field>
                            </td>
                            <td> <v-text-field v-if="i==0" :value="d.diferencia" prefix="Bs." type="number" readonly dense outline hide-details></v-text-field>  </td>
                        </tr> 
                        <tr style="background-color: #161d30;">
                          <td></td>
                          <td> <small> {{ denominaciones[0].egreso + denominaciones[1].egreso }} bs </small> </td>
                          <td> <small> {{ denominaciones[0].ingreso + denominaciones[1].ingreso }} bs </small> </td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
                </div>

                <v-progress-linear v-if="loading" indeterminate color="green darken-2"></v-progress-linear>
                <p class="text-center red--text"> {{ msg }} </p>

                <div class="text-center">
                  <v-btn :disabled="loading || loading_denominaciones" :loading="loading" tile color="red darken-2" dark class="" @click="registrar()" >
                    Cerrar caja
                  </v-btn>
                  <v-btn :disabled="loading || loading_denominaciones" :loading="loading" tile color="green darken-2" dark class="ml-4" @click="dialog=!dialog" >
                    Cerrar ventana
                  </v-btn>
                </div> 
            </v-form>
        </v-card-text> 
      </v-card>
  
      <contador ref="refcontador" v-on:oncontador="oncontador" />
      </v-dialog>
    </div>
  </template>

<script>
import xaxios from '@/xaxios'; 
import contador from './contador.vue'

export default {
  data () {
    return {
      dialog: false,
      valid: true,
      loading: false, 
      loading_denominaciones: false, 
      msg: '',
      loading_usus: false,
      select: null,
      items: [ ],
      checkbox: false,
      item: {}, 
      fecha_ini: null,
      efectivo: null,
      denominaciones: [
        {id:1,text:'EFECTIVO', egreso:0,ingreso:0,calculado:0,contado:0,diferencia:0},
        {id:2,text:'TRANSACCION BANCARIA', egreso:0,ingreso:0,calculado:0,contado:0,diferencia:0},
      ],
      suma_efectivo_eg:0,
      suma_efectivo_in:0,
      suma_bancaria_eg:0,
      suma_bancaria_in:0,
      arcos:[],
    }
  },
  components:{ contador },
  computed:{ },


  methods: {
    openmodal(item=null){
      this.item = {};
        this.dialog = true; 
        this.valor = '';
        this.item = item;
        this.suma_efectivo_eg = 0;
        this.suma_efectivo_in = 0;
        this.suma_bancaria_eg = 0;
        this.suma_bancaria_in = 0;
        this.denominaciones[0].contado = 0;
        

        if(item){
          const vue = this;
          if(!item.movimientos) item.movimientos = [];
          item.movimientos.forEach(x=>{
            if(x.tipo == "INGRESO") {
              vue.suma_efectivo_in += parseFloat((x.efectivo*1).toFixed(2));
              vue.suma_bancaria_in += parseFloat((x.transferencia_bancaria*1).toFixed(2));

            } else {
              vue.suma_efectivo_eg += parseFloat((x.efectivo*1).toFixed(2));
              vue.suma_bancaria_eg += parseFloat((x.transferencia_bancaria*1).toFixed(2));
            }
          });
          let efectivo = this.denominaciones.find(x=>x.id==1);
          let bancarias = this.denominaciones.find(x=>x.id==2);

          efectivo.egreso = this.suma_efectivo_eg;
          efectivo.ingreso = this.suma_efectivo_in;

          bancarias.egreso = this.suma_bancaria_eg;
          bancarias.ingreso = this.suma_bancaria_in;

          efectivo.calculado = efectivo.ingreso - efectivo.egreso;
          bancarias.calculado = bancarias.ingreso - bancarias.egreso;
          this.denominaciones[0].diferencia = this.denominaciones[0].contado - this.denominaciones[0].calculado; 
        }
        //window.console.log('>>>: ',item);
    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      gettotal(d){
        const v = parseFloat((d.xcantidad*d.valor).toFixed(2))
        return v;
      }, 
      opencontador(denominacion){
        this.arcos = [];
        this.$refs.refcontador.openmodal(denominacion, this.denominaciones);
      },
      oncontador(arcos){
        this.arcos = arcos; 
      },

      async registrar(){
        this.msg = '';
        if(!this.$refs.form.validate()) return;
        // if(!this.denominaciones[0].contado) this.msg = `ingrese las cantidades de las denominaciones para el valor 'contado'`; 
        if(!this.denominaciones[0].contado) this.denominaciones[0].contado = 0; 
        if(this.msg) return;

        let message = {
            title: 'Verificacion antes de proceder:',
            body: '<br> <b>NOTA:</b> Esta accion es irreversible',
        };
        let options = {
            html: true,
            okText: 'Proceder',
            cancelText: 'Cancelar',
            reverse: true,
            type: 'soft',
            verification: 'cerrar',
            verificationHelp: 'Escriba "[+:verification]" para proceder.',
            loader: true,
        };
        let dialogo = await this.$dialog.confirm(message, options).then(d=>d).catch(e=>e);
        // window.console.log( 'typeof(dialogo)',typeof(dialogo),dialogo ); 
        if(!dialogo) return;
        dialogo.close(); 

        
        this.loading = true;
        const arqueos = [];
        const vue = this;
        let calc = 0; // calculado general
        let diff = 0; // diferencia general
        calc = this.denominaciones[0].ingreso - this.denominaciones[0].egreso;
        diff = this.denominaciones[0].contado - this.denominaciones[0].calculado; 

        this.arcos.forEach((x,i)=>{
          let xtotal = parseFloat((x.valor * x.cantidad).toFixed(2));
          let xvalor = parseFloat((x.valor * 1).toFixed(2));
          arqueos.push(
            {denominacion_id:x.id,valor:xvalor,cantidad:x.cantidad,total:xtotal}
          ); 
          if(!x.valor) vue.msg = `Falta el valor para la denominacion: ${i+1}`;
          // if(!x.cantidad) vue.msg = `Falta la cantidad para la denominacion: ${i+1}`;
        });
        
        const input = {  
            caja_id: this.item.id,
            calculado: parseFloat((calc * 1).toFixed(2)),
            diferencia: parseFloat((diff * 1).toFixed(2)),
            arqueo: arqueos,
        }

        // window.console.log(JSON.stringify(input,null,2), axios); 
        // if(this.msg) return;

        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/cierre`; 
        const res = await xaxios.post(url,input).then(x=>x).catch(x=>x);
        window.console.log('cierre: ',res);
        if(res && res.response){
          let xms = res.response.data.data;  
          this.msg = xms;
        }else if(res && res.data){
          this.$root.$notify.show(`caja cerrada`, {color:'#03931D',x: 'right',y:'top'});
          this.dialog = false; 
          this.$emit('onclose');
          this.saveArchivo(res.data.data.reporte)
        }
        
        this.loading = false;
      },

      getdatauri(archivo){
        if(!archivo) return '';
        return `data:${archivo.mimetype};base64,${archivo.file64}`
      },
      saveArchivo(reporte){
        const imgUri = this.getdatauri(reporte);
        const link = document.createElement('a')
        document.body.appendChild(link)

        link.href = imgUri
        link.target = '_self'
        link.fileName = `CierreCaja-${reporte.created_at}.${reporte.extencion}`;
        link.download = `CierreCaja-${reporte.created_at}.${reporte.extencion}`;
        link.click()
    },

      msgErr(res){ 
        try{ this.msg = res.response.data.data; }
        catch(e){ this.msg = res }
      }
    }, 
}
</script>